import React, { useState } from "react";
import request from "src/utils/request";
import { ToastContext } from "src/components/providers/toast-provider";
import { Divider, Grid, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import MissionsCategoryToggle from "src/scenes/dashboard/overview-components/missions-category-toggle";
import MissionSelectionToggle from "src/scenes/dashboard/overview-components/missions-selection-toggle";
import MissionsSectionComponent from "src/scenes/dashboard/overview-components/missions-section-component";
import styled from "styled-components";
import { useAuth } from "src/components/providers/auth-context";
import { addWeeks, differenceInDays } from "date-fns";
import { useLocation } from "react-router-dom";

const SubtitleText = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const MissionsTeams = ({ isProd }) => {
    const { setMessage, setSeverity, setIsToastTriggered, setIsTeamMissions, setMissionTeamId } =
        React.useContext(ToastContext);
    const [allMissions, setAllMissions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("work");
    const [selectedMissionId, setSelectedMissionId] = useState("");
    const [missionTarget, setMissionTarget] = useState(0);
    const [missionEndDate, setMissionEndDate] = useState(addWeeks(new Date(), 1));
    const { isDemo } = useAuth();

    const location = useLocation();
    const teamId = location.state && location.state.teamId;
    const teamName = location.state && location.state.teamName;

    const getAllMissions = async () => {
        let response;
        if (isDemo) {
            response = (await import("./teams-missions-mock-data")).default;
        } else {
            response = await request(`/api/missions`, { method: "GET" });
        }
        setAllMissions(response);
    };

    const createMission = async () => {
        const daysDuration = differenceInDays(missionEndDate, new Date()) + 1;
        const requestUrl = `/api/missions/team/${teamId}`;
        await request(requestUrl, {
            method: "POST",
            body: JSON.stringify({
                missionId: selectedMissionId,
                target: missionTarget,
                daysDuration,
            }),
        });
        setMessage(`Mission created successfully`);
        setIsTeamMissions(true);
        setMissionTeamId(`${teamId}`);
        setSeverity("success");
        setIsToastTriggered(true);
    };

    const handleSubmitStart = async () => {
        try {
            createMission();
        } catch (e) {
            setMessage(`Error creating mission. Please try again.`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };

    React.useEffect(() => {
        getAllMissions();
    }, []);

    if (allMissions.length === 0) return null;
    return (
        <Stack>
            <Stack direction="row" style={{ width: "100%" }} justifyContent="space-between">
                <Stack direction="column">
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {`Set Mission for ${teamName}`}
                    </Typography>
                    <SubtitleText id="modal-modal-description" sx={{ mt: 2 }}>
                        Edit parameter and a set mission.
                    </SubtitleText>
                </Stack>
            </Stack>
            <Stack
                direction="column"
                sx={{
                    width: "100%",
                    typography: "body1",
                    paddingTop: "26px",
                }}
                spacing={2}
                justifyContent="space-between"
            >
                <Typography id="modal-modal-title" style={{ fontSize: "12px", fontWeight: "200" }}>
                    Select Category
                </Typography>
                <MissionsCategoryToggle
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                />
                <Grid container direction="row" style={{ width: "100%" }}>
                    <Grid item md={8} paddingRight={3}>
                        <Typography
                            id="select-mission"
                            style={{ fontSize: "12px", fontWeight: "200" }}
                        >
                            Select Mission
                        </Typography>
                        <MissionSelectionToggle
                            allMissions={allMissions}
                            selectedMissionId={selectedMissionId}
                            setSelectedMissionId={setSelectedMissionId}
                            selectedCategory={selectedCategory}
                            setMissionTarget={setMissionTarget}
                            style={{ marginTop: "12px" }}
                        />
                    </Grid>
                    <Divider
                        orientation="vertical"
                        variant="middle"
                        flexItem
                        style={{ marginTop: "32px" }}
                    />
                    <Grid item md={3} paddingLeft={3}>
                        <Typography id="set-goal" style={{ fontSize: "12px", fontWeight: "200" }}>
                            Set Goal
                        </Typography>
                        <MissionsSectionComponent
                            isDemo={isDemo}
                            isProd={isProd}
                            allMissions={allMissions}
                            selectedMissionId={selectedMissionId}
                            selectedCategory={selectedCategory}
                            missionTarget={missionTarget}
                            setMissionTarget={setMissionTarget}
                            missionEndDate={missionEndDate}
                            setMissionEndDate={setMissionEndDate}
                            handleSubmitStart={handleSubmitStart}
                        />
                    </Grid>
                </Grid>
            </Stack>
        </Stack>
    );
};

export default MissionsTeams;
